import styled from "styled-components";
import {
  borderRadius,
  borderWidth,
} from "../../../design-system/tokens/borders";
import { spacing } from "../../../design-system/tokens/spacing";
import { typographyMixin } from "../../../design-system/tokens/typography";

export const HeaderRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  gap: ${spacing[2]};
  cursor: pointer;
`;

export const LabelGroup = styled.div`
  display: flex;
  align-items: center;
  gap: ${spacing[2]};
  min-width: 0;
`;

export const IconSlot = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  color: ${({ theme }) => theme.colors.text.secondary};
  flex-shrink: 0;
  // background-color: red;
`;

export const Label = styled.span`
  ${typographyMixin("subtitle", 3)}
  color: ${({ theme }) => theme.colors.text.primary};
`;

export const CountBadge = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 2px ${spacing[2]};
  background-color: ${({ theme }) => theme.colors.surface.secondary};
  border: ${borderWidth[1]} solid ${({ theme }) => theme.colors.border.subtle};
  border-radius: ${borderRadius.sm};
  ${typographyMixin("overline", 3)}
  color: ${({ theme }) => theme.colors.text.secondary};
`;

export const Actions = styled.div`
  display: flex;
  align-items: center;
  gap: ${spacing[2]};
  flex-shrink: 0;
`;

export const IconButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  padding: 0;
  border: none;
  background: transparent;
  color: ${({ theme }) => theme.colors.text.interactive};
  cursor: pointer;
  border-radius: ${borderRadius.sm};

  &:hover {
    background-color: ${({ theme }) => theme.colors.surface.secondary};
  }

  &:focus-visible {
    outline: 1px solid ${({ theme }) => theme.colors.interactive.primary};
    outline-offset: 2px;
  }

`;

export const Chevron = styled.span<{ $isOpen: boolean }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  color: ${({ theme }) => theme.colors.text.secondary};
  transition: transform 0.2s ease;
  transform: rotate(${({ $isOpen }) => ($isOpen ? "180deg" : "0deg")});
`;
